import {DateTime} from 'luxon';

export function toDateTimeHelper(date: string | null): DateTime | null {
  return date ? DateTime.fromISO(date) : null;
}
